var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('app-header',{attrs:{"pathArray":_vm.pathArray}}),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"page-container"},[(_vm.sideBarShow)?_c('side-bar'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"one-farm",staticStyle:{"overflow-y":"auto"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fcc2cf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/index.vue
// module id = null
// module chunks = 